import { computed, inject, ref } from 'vue'

import { usePwaInstall } from '@/shared/composables/usePwaInstall'

/**
 * Одно поведение кнопки «Установить приложение» для всех мест, где она есть
 * (карточка в профиле, шторка гамбургера): системный диалог, где он есть;
 * инструкция, где нет; ссылка на мини-апп внутри Telegram; ничего — если
 * уже установлено.
 */
export function usePwaInstallAction() {
  const isInTelegram = inject<boolean>('isInTelegram', false)
  const { canPrompt, isInstalled, prompt } = usePwaInstall()

  const guideOpen = ref(false)

  const telegramBotUsername = ((import.meta.env.VITE_GONKAGAME_TELEGRAM_BOT_USERNAME as string | undefined) || '').replace(/^@/, '')
  const telegramInstallUrl = computed(() =>
    telegramBotUsername ? `https://t.me/${telegramBotUsername}/?startapp&addToHomeScreen` : '',
  )

  async function install(): Promise<void> {
    if (canPrompt.value) {
      // Отказался в системном диалоге — инструкцию не навязываем.
      await prompt()
      return
    }
    guideOpen.value = true
  }

  return { isInTelegram, isInstalled, telegramInstallUrl, guideOpen, install }
}
